import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import smoothscroll from 'smoothscroll-polyfill'
import axios from 'axios'
import VueAxios from 'vue-axios'

smoothscroll.polyfill()
createApp(App).use(Quasar, quasarUserOptions).use(store).use(VueAxios, axios).use(router).mount('#app')
